const actionTypes = {
  SET_ALL_RATING_TEMPLATES: 'SET_ALL_RATING_TEMPLATES',
  UPSERT_RATING_TEMPLATE: 'UPSERT_RATING_TEMPLATE',
  DELETE_RATING_TEMPLATE: 'DELETE_RATING_TEMPLATE',
};

export function setAllRatingTemplates(ratingTemplates) {
  return { type: actionTypes.SET_ALL_RATING_TEMPLATES, ratingTemplates };
}

export function upsertRatingTemplate(ratingTemplate) {
  return { type: actionTypes.UPSERT_RATING_TEMPLATE, ratingTemplate };
}

export function deleteRatingTemplate(ratingTemplateId) {
  return { type: actionTypes.DELETE_RATING_TEMPLATE, ratingTemplateId };
}

export default function ratingTemplateReducer(
  state = {
    ratingTemplates: [],
  },
  action
) {
  switch (action.type) {
    case actionTypes.SET_ALL_RATING_TEMPLATES: {
      return { ...state, ratingTemplates: action.ratingTemplates };
    }
    case actionTypes.UPSERT_RATING_TEMPLATE: {
      return {
        ...state,
        ratingTemplates: [
          ...state.ratingTemplates.filter(
            (t) => t.id !== action.ratingTemplate.id
          ),
          action.ratingTemplate,
        ],
      };
    }
    case actionTypes.DELETE_RATING_TEMPLATE: {
      return {
        ...state,
        ratingTemplates: [
          ...state.ratingTemplates.filter(
            (t) => t.id !== action.ratingTemplateId
          ),
        ],
      };
    }
    default:
      return state;
  }
}

export const ratingTemplatesSelector = (state) =>
  state.ratingTemplateReducer.ratingTemplates;
